module.exports = __webpack_public_path__ + "img/land_baoli.46e34a0b.png";